import { useEffect, useState } from 'react';

import { SearchOutlined } from 'farmhub-ui-core';

import { theme } from 'styled';

import { Wrapper, WrapperAction } from './styles';

interface SearchTableProps {
  value?: string;
  placeholder: string;
  width?: number | string;
  maxWidth?: number;
  height?: 'xs' | 'sm' | 'md' | 'lg';
  background?: string;
  fontSize?: string;
  suffix?: React.ReactNode;
  styles?: any;
  isFocus?: boolean;
  extraAction?: React.ReactNode;
  searchOnChange?: boolean;
  onEnter?: (e: any) => void;
  onChange?: (e: any) => void;
}

const SearchTable = ({
  value = '',
  width,
  maxWidth,
  height = 'md',
  placeholder,
  background,
  fontSize,
  styles,
  suffix,
  isFocus,
  extraAction,
  searchOnChange,
  onEnter,
  onChange = () => 0,
}: SearchTableProps): JSX.Element => {
  const [isSearching, setIsSearching] = useState(false);
  const [valueChange, setValueChange] = useState('');

  useEffect(() => {
    setValueChange(value);
  }, [value]);

  const handleChange = (e): void => {
    setValueChange(e.target.value);

    if (searchOnChange) {
      onChange(e);
      e.preventDefault();
    }
  };

  const handlePressEnter = (e: any): void => {
    onChange(e);
    onEnter && onEnter(e);
    e.preventDefault();
  };

  useEffect(() => {
    if (isFocus) {
      const inputRef = document.getElementById('input-search');
      inputRef?.focus();
    }
  }, [isFocus]);

  return (
    <>
      <Wrapper
        allowClear
        background={background || (isSearching ? '#fff' : '#fff')}
        fontSize={fontSize}
        height={height}
        placeholder={width ? placeholder : isSearching ? placeholder : ''}
        prefix={
          <SearchOutlined
            style={{ fontSize: '18px', color: theme.colors.text.secondary }}
          />
        }
        size="large"
        styles={extraAction ? { ...styles, paddingRight: '35px' } : styles}
        suffix={suffix}
        value={valueChange}
        width={width || (isSearching ? maxWidth || 240 : 42)}
        onBlur={() => setIsSearching(false)}
        onChange={handleChange}
        onFocus={() => setIsSearching(true)}
        onPressEnter={handlePressEnter}
      />
      {extraAction ? <WrapperAction>{extraAction}</WrapperAction> : null}
    </>
  );
};

export default SearchTable;
